import React from 'react';

const DataUContext = React.createContext();

export default DataUContext;